import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import "./news-card.scss";

const useStyles = makeStyles({
   
    media: {
      height: 250,
      borderTopLeftRadius: 25,

    },
  });
  
  export default function NewsCard({newsImage,newsTitle,newsDate,newsDescription}) {
    const classes = useStyles();
  
    return (
    <div className="news-card">
        <Card className="card-root">
            <CardActionArea>
            <CardMedia
                className={classes.media}
                image={newsImage}
                title="Latest News"
            />
            <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                {newsTitle}
                
                </Typography>
                <p className="news-date">{newsDate}</p>
                <Typography variant="body2" color="textSecondary" component="p">
                {newsDescription}
                </Typography>
            </CardContent>
            </CardActionArea>
        </Card>
    </div>
    );
  }